"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatterOptions = void 0;
class FormatterOptions {
  objectMode = true;
  delimiter = ',';
  rowDelimiter = '\n';
  quote = '"';
  escape = this.quote;
  quoteColumns = false;
  quoteHeaders = this.quoteColumns;
  headers = null;
  includeEndRowDelimiter = false;
  transform;
  shouldWriteHeaders;
  writeBOM = false;
  escapedQuote;
  BOM = '\ufeff';
  alwaysWriteHeaders = false;
  constructor() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(this, opts || {});
    if (typeof opts?.quoteHeaders === 'undefined') {
      this.quoteHeaders = this.quoteColumns;
    }
    if (opts?.quote === true) {
      this.quote = '"';
    } else if (opts?.quote === false) {
      this.quote = '';
    }
    if (typeof opts?.escape !== 'string') {
      this.escape = this.quote;
    }
    this.shouldWriteHeaders = !!this.headers && (opts.writeHeaders ?? true);
    this.headers = Array.isArray(this.headers) ? this.headers : null;
    this.escapedQuote = `${this.escape}${this.quote}`;
  }
}
exports.FormatterOptions = FormatterOptions;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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